import React, { useEffect,useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import './ForgotPassword.css';
import Topbar from "../../Topbar";
import Footer from "../../Footer";
import { useNavigate } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import {validateforgotpassword} from '../../../Utils/validate';
import loader from '../../../assests/loader.gif';
import API from '../../../Utils/Api';
import { gettoastwarning } from '../../../Utils/Common';

const ForgotPassword = () => {
	const [loading,setLoading] = useState(false);
	const navigate = useNavigate();

	const [inputs,setInputs] = useState({email:''})

	const [errors,setErrors] = useState({});

	useEffect(() => {
		document.title = `Forgot Password | Local Bells`;
		document.getElementById('bodywrap').className = 'nefp';
	}, []);

	/* Start Value set */
	const handleInputChange = (event) => {
	  event.persist();
	  setInputs(inputs => ({...inputs, [event.target.name]: event.target.value}));       
	}
	/* End Value set */

	const handleSubmit = (e) => {
		e.preventDefault();
		const validationErrors = validateforgotpassword(inputs);
     	const noErrors = Object.keys(validationErrors).length === 0;
		setErrors({});
        setErrors(validationErrors);
		
		if(noErrors){
			setLoading(true);
			let email=inputs.email;
		    let formData = new FormData(); 
		    formData.append('email', email);
		    formData.append('type', 1);
		    API.post('forgot_password', formData)
		      .then(response => {
		      if(response.data.status === false){
		        //setError(response.data.message);
		        setLoading(false); 
		        gettoastwarning(response.data.message,'');
		      }else{
		      	localStorage.setItem("email", email);
		         setLoading(false);
		         navigate('/neighbour/otp');
		      }                  
		    }).catch(error => {
		       setLoading(false);
		       gettoastwarning("Something went wrong. Please try again later.",'');
		        //setError("Something went wrong. Please try again later.");
		    });				
		}
	};
	return (
		<>
			<Topbar />
			<Container>
				<section className='signup-main'>
						<Row className='justify-content-center'>
							<Col md={8} lg={5} xs={12}>
								<div className="signup-form-box">
									<div className='sfb-title mb-5'>
										<h2 className=''><span>Forgot Password</span></h2>
										<h5>Enter your email address</h5>
									</div>
									<Form onSubmit={handleSubmit}>
										<Form.Control type="text" placeholder="email address" className='mv-15' name="email" onChange={handleInputChange} value={inputs.email}/>
										{errors.email && (<p className="text-danger">{errors.email}</p>)}
										<Button variant="primary" type="submit" className='blue-btn mt-0'>
											<h6>Submit</h6>
										</Button>
									</Form>

								</div>
							</Col>
						</Row>
				</section>
			</Container>
			<Footer />
			{loading && (
		       <div className="loadingClass">
		        <img src={loader} alt="loader"/>
		      </div>
		       )}  
		</>
	)
}

export default ForgotPassword;
